import React from "react";
import ReactDOM from "react-dom";
// import Handlebars from "handlebars";
const { data } = require('./Testimonials.data');

import "./Testimonials.scss";

// const htmlContent = require("./Testimonials.html");
import htmlContent from './Testimonials.hbs';// works as template fn

// const template = Handlebars.compile(htmlContent);// fails

const Testimonials = (props) => {

  const {
    // data,
  } = props;

  const h_cont = htmlContent(data);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: h_cont }} className={`hbs_comp`} />
      {/* <div dangerouslySetInnerHTML={{ __html: template(data) }} /> */}
    </>
  );
}

export default Testimonials
